// extracted by mini-css-extract-plugin
export default {"loader":"Chart_loader__FvUZy","loader_black":"Chart_loader_black__PKXtt","loader_2":"Chart_loader_2__7i3O5","loader2-1":"Chart_loader2-1__VMhwH","loader2-2":"Chart_loader2-2__ZaTJR"};